<template>
  <div class="modal_card reverse user-add-modal">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Выберите пользователей</h1>
      <form @submit.prevent="$emit('submit')">
        <ul class="course-categories">
          <li class="list_header" v-for="(user, i) in usersList" :key="i">
            <b-field class="input_checkbox">
              <b-checkbox
                v-model="checked.users"
                :native-value="user.id"
                type="is-info">{{ `${user.surname} ${user.name} ${user.patronymic} - ${user.email}` }}</b-checkbox>
            </b-field>
          </li>
        </ul>
        <b-pagination
          :total="total"
          :current="search.usersPage"
          :simple="true"
          :size="'is-small'"
          :order="'is-right'"
          @change="pageChanged"
          :per-page="15">
        </b-pagination>
        <button class="add_user_button modal_button left_button" type="submit" :disabled="!checked.users.length">
          Подтвердить
        </button>
        <button type="button" @click="$emit('close-modal')" class="close_button modal_button right_button">
          Отмена
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    usersList: {
      default: () => [],
      type: Array,
    },
    total: {
      default: () => 1,
      type: Number,
    },
    checked: {
      default: () => {},
      type: Object,
    },
    search: {
      default: () => {},
      type: Object,
    },
  },
  methods: {
    pageChanged(page) {
      this.search.usersPage = page;
      this.$emit('pageChange');
    },
  },
}
</script>
